import React from "react";

const Accueil = () => {
  return (
    <>
      <header className="row d-flex justify-content-center header">
        <h1 className="title text-center text-uppercase pt-4 pb-4">
          demande en ligne d'autorisation de changement d'usage à caractère
          personnel d'un local d'habitation
        </h1>
        <div className="divider--title m-4"></div>
      </header>
      <section className="p-3">
        <p className="m-1">
          <strong className="d-block mb-3">
            Ce formulaire est destiné aux propriétaires personnes physiques
            souhaitant pratiquer la location meublée touristique.
          </strong>
          La demande de changement d'usage doit être formulée par le
          propriétaire du logement personne physique (cf. article L.631-7-1-A du
          Code de la construction et de l'habitation).
          <br />
          Dans le cadre de ce dispositif, on entend par propriétaire, la
          personne physique figurant sur l'acte de propriété.
          <br />
          Selon le code de la construction et de l'habitation, l'autorisation
          est délivrée à un "même propriétaire". Le propriétaire déclarant peut
          être:
        </p>
        <>
          <ul style={{ listStyleType: "none" }}>
            <li>En pleine propriété</li>
            <li>Usufruitier</li>
            <li>
              Une division (considérée comme un même propriétaire même si elle
              concerne plusieurs propriétaires, nécessite l'accord préalable de
              tous les propriétaires indivis).
            </li>
          </ul>
        </>
        <p>
          <strong>
            Caractéristiques et modalités de délivrance des autorisations
            temporaires.
          </strong>
          <br />
        </p>
        <ul>
          <li>
            Les autorisations temporaires sont accordées pour une durée de 3 ans
            et au maximum jusqu'au 30 avril 2027.
          </li>
          <li>
            Toute reconduction devra faire l'objet d'une nouvelle demande.
          </li>
          <li>
            Ces autorisations sont temporaires et nominatives, attachées à la
            personne, elles sont donc incessibles.
          </li>
          <li>
            Il ne sera pas possible de transférer ces autorisations sur d'autres
            biens détenus par un même propriétaire.
          </li>
          <li>
            Ces autorisations cesseront à l'arrivée du terme ou de manière
            anticipée, sur demande écrite du propriétaire ou nouvelle décision
            de l'administration.
          </li>
        </ul>
      </section>
    </>
  );
};

export default Accueil;
